import { store } from 'redux/store';
import { getAuth } from 'redux/reducers/auth/selectors';
import { DateTime } from 'luxon';
import { DeviceInfo, collectDeviceInfo } from 'services/deviceInfo';
import { IAxiosRequestConfig } from './types';

// ==========================================:
export const onSuccess = (config: IAxiosRequestConfig) => {
	const requestConfig = config;
	const state = store.getState();
	const auth = getAuth(state);
	const { refreshTime, refreshToken } = auth;
	const deviceInfo: DeviceInfo = collectDeviceInfo();

	if (auth.accessToken && auth.xMerchantId) {
		requestConfig.headers = {
			Authorization: `Bearer ${String(auth.accessToken)}`,
			'X-Merchant-Id': auth.xMerchantId,
			Accept: 'text/plain',
			'Content-Type': 'application/json',
			...deviceInfo,
		};
	} else if (auth.accessToken) {
		requestConfig.headers = {
			Authorization: `${String(auth.accessToken)}`,
		};
	}
	if (refreshToken && refreshTime && refreshTime < Date.now()) {
		// console.log(
		// 	DateTime.now().toFormat('HH:mm:ss'),
		// 	'refreshTokenRequest!!!!',
		// 	DateTime.fromMillis(refreshTime).toISO(),
		// );
	}

	return requestConfig;
};

export const onSuccessRefresh = (config: IAxiosRequestConfig) => {
	const requestConfig = config;
	const state = store.getState();
	const auth = getAuth(state);

	if (auth.xMerchantId) {
		requestConfig.headers = {
			'X-Merchant-Id': auth.xMerchantId,
		};
	}

	return requestConfig;
};
